/* Конец диапазона у FullCalendar не включается, поэтому сравнение строгое */
export const isDateInRange = (date: Date, start: Date, end: Date): boolean =>
  date.getTime() >= start.getTime() && date.getTime() < end.getTime()
